import React, { useState, useContext } from 'react';
import api from '../api';
import { UserContext } from '../UserContext';

function Payments() {
  const { user } = useContext(UserContext);

  const handleClick = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post('/api/checkout/session/');
      if (res.status === 201) {
        window.location.href = res.data.url;
      }
    } catch (error) {
    }
  }
  const handleManageSubscription = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post('/api/customer-portal/');
      if (res.status === 201) {
        window.location.href = res.data.url;
      }
    } catch (error) {
      alert("Error while redirecting to customer portal");
    }
  }

  function Pay() {
    const [code, setCode] = useState("");

    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        const res = await api.post('/api/check-promo/', { code });
        if (res.status === 200) {
          window.location.reload();
        }

      } catch (error) {
        alert("Promo Code is not valid.");
      }
    }

    return (
      <div>

        <li className="list-group-item">
          <button type="submit" className="btn btn-outline-primary" onClick={handleClick}>
            Pay
          </button>
        </li>
        <form onSubmit={handleSubmit} >

          <li className="list-group-item">
            <input
              placeholder="Promo Code"
              className="form-control"
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              maxLength={511}
              required
            />
            <button style={{ marginTop: "10px" }} type="submit" className="btn btn-success">
              Check
            </button>
          </li>
        </form>
      </div>
    )
  }
  function Manage() {

    if (user.subscription.promocode_used) {
      return (
        <li className="list-group-item">
          <p>You have used a lifetime valid promotional code</p>
        </li>
      )
    }
    else {
      return (
        <div>
          <li className="list-group-item">
            <button className="btn btn-outline-secondary" type="button" onClick={handleManageSubscription}>
              Manage subscription
            </button>
          </li>
        </div>
      )
    }

  }
  function Info() {
    const formated_date = (date) => { return date.match(/^\d{4}-\d{2}-\d{2}/)[0]; }

    return (
      <div>
        <li className="list-group-item">
          <ul className="list-group list-group-flush">
            <li className="list-group-item">started at : {user.subscription.started_at ? formated_date(user.subscription.started_at) : "---"}</li>
            <li className="list-group-item">cancel at : {user.subscription.cancel_at ? formated_date(user.subscription.cancel_at) : "---"}</li>
            <li className="list-group-item">canceled at : {user.subscription.canceled_at ? formated_date(user.subscription.canceled_at) : "---"} </li>
            {/* <li className="list-group-item">ended at : {user.subscription.ended_at ? formated_date(user.subscription.ended_at) : "---"} </li> */}
            <li className="list-group-item">status : {user.subscription.status ? user.subscription.status : "---"} </li>
          </ul>
        </li>
      </div >
    )
  }

  return (
    <div className='w-100 mt-3' style={{ marginBottom: "30px" }} >
      <ul className="list-group">
        {user.subscription.status === "active" ?

          <Manage />
          :
          <Pay />
        }
        {user.subscription.started_at ? <Info /> : null}
      </ul>
    </div>
  )
}
export default Payments;
